import { render, staticRenderFns } from "./AromaCheckout.vue?vue&type=template&id=652de1b0&scoped=true"
import script from "./AromaCheckout.vue?vue&type=script&lang=js"
export * from "./AromaCheckout.vue?vue&type=script&lang=js"
import style0 from "./AromaCheckout.vue?vue&type=style&index=0&id=652de1b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652de1b0",
  null
  
)

export default component.exports